import {
  Swiper,
  Navigation,
  Autoplay,
  // Scrollbar,
} from 'swiper';
import barba from '@barba/core';

Swiper.use([Navigation, Autoplay]);

const navigation = (target) => {
  const swiperClass = {
    nextEl: '.' + target + '-swiper-controls__next',
    prevEl: '.' + target + '-swiper-controls__prev',
  };

  return swiperClass;
};

const colPadding = 50; // 2x de .col padding

$(window).on('load', function () {
  swipers();
});

const swipers = () => {
  gallery();
  vacature();
  video();
  actueel();
  review();
  scholen();
  home();
};

const gallery = () => {
  return new Swiper('.gallery-swiper', {
    slidesPerView: 2,
    navigation: navigation('gallery'),
    spaceBetween: colPadding,
    observer: true,
    observeParents: true,
    breakpoints: {
      768: {
        slidesPerView: 2.4,
        spaceBetween: 50,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
  });
};

const video = () => {
  return new Swiper('.video-swiper', {
    slidesPerView: 1,
    navigation: navigation('video'),
    spaceBetween: 50, // 2x de .col padding
    observer: true,
    observeParents: true,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
  });
};


const vacature = () => {
  return new Swiper('.vacature-swiper', {
    slidesPerView: 1,
    navigation: navigation('vacature'),
    spaceBetween: 50, // 2x de .col padding
    observer: true,
    observeParents: true,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
  });
};

const actueel = () => {
  new Swiper('.actueel-swiper', {
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      993: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
    navigation: navigation('actueel'),
    spaceBetween: colPadding,
    observer: true,
    observeParents: true,
  });
};

const review = () => {
  new Swiper('.reviewslider-swiper', {
    breakpoints: {
      993: {
        slidesPerView: 3,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: navigation('review'),
    spaceBetween: colPadding,
    observer: true,
    observeParents: true,
    loop: true,
  });
};

const scholen = () => {
  new Swiper('.scholenslider-swiper', {
    breakpoints: {
      768: {
        slidesPerView: 4,
      },
      0: {
        slidesPerView: 1.5,
      },
    },
    loop: true,
    navigation: navigation('scholenslider'),
    spaceBetween: colPadding,
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 2000,
    },
  });
};

const home = () => {
  new Swiper('.home-swiper', {
    loop: true,
    spaceBetween: 0,
    allowTouchMove: false,
    autoplay: {
      delay: 5000,
    },
    observer: true,
    observeParents: true,
  });
};

barba.hooks.after(() => {
  swipers();
});
